import { Autocomplete, Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import headerImg from './skillx.png';
import useResponsive from '../../../../Hooks/useResponsive';
import { ReactTyped } from 'react-typed';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import PercentageCurrencyType from './FeeAutomation/PercentageCurrencyType';
const CartHeader = ({ setSelectedCourse, selectedCourse, CourseDetails, setTotalCourses, availableCartItems }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { leadDetails, loading } = useSelector((state) => state.cart);
  const [CurrencyType, setCurrencyType] = useState('');
  const [open, setOpen] = useState(false);
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  const handleCurrencyTypeChange = (event) => {
    setCurrencyType(event.target.value);
  };
  const handleSave = () => {
    if (selectedCourse) {
      if (!CurrencyType) {
        enqueueSnackbar('Please Select Currency Type...!', {
          variant: 'error',
        });
      } else if (CurrencyType) {
        const AddedData = { ...selectedCourse, selectedCurrency: CurrencyType };
        setTotalCourses((prevArray) => {
          enqueueSnackbar('Course Added Successfully...!', {
            variant: 'success',
          });
          return [...prevArray, AddedData];
        });
        setOpen(false);
        setCurrencyType('');
      }
    }
  };
  const handleChange = (event) => {
    setSelectedCourse(event.target.value);
  };
  const handleSubmit = () => {
    if (selectedCourse) {
      const isAlreadyInCart = availableCartItems.some((item) => item.id === selectedCourse.id);

      if (isAlreadyInCart) {
        enqueueSnackbar('Already Exist in Cart..!', { variant: 'error' });
      } else {
        setTotalCourses((prevArray) => {
          const exists = prevArray.some((item) => item.id === selectedCourse.id);
          if (!exists) {
            if (selectedCourse.courseTypeId == 1) {
              enqueueSnackbar('Course Added Successfully...!', {
                variant: 'success',
              });
              return [...prevArray, selectedCourse];
            } else {
              setOpen(true);
            }
          } else {
            enqueueSnackbar('Already Exist..!', {
              variant: 'error',
            });
          }
          return prevArray;
        });
      }
    }

    // if (selectedCourse) {
    //   if (availableCartItems?.length >= 1) {
    //     enqueueSnackbar("Only one course at a time...!", { variant: "error" });
    //   } else {
    //     setTotalCourses((prevArray) => {
    //       // const exists = prevArray.some(
    //       //   (item) => item.id === selectedCourse.id
    //       // );
    //       if (prevArray?.length == 0) {
    //         enqueueSnackbar("Course Added Successfully...!", {
    //           variant: "success",
    //         });
    //         return [...prevArray, selectedCourse];
    //       } else {
    //         enqueueSnackbar("Only one course at a time...!", {
    //           variant: "error",
    //         });
    //       }
    //       return prevArray;
    //     });
    //   }
    // }
  };
  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 100, damping: 20 }}
    >
      <Box sx={{ position: 'relative' }}>
        <Paper
          sx={{
            width: '100%',
            height: smUp ? 210 : 320,
            background: 'linear-gradient(120deg, #0089d0 10%, #0089d0 50%, #f8f8f9ff 90%)',
            borderRadius: 3,
            position: 'relative',
            animation: 'gradientMove 6s ease infinite',
            '@keyframes gradientMove': {
              '0%': { backgroundPosition: '0% 50%' },
              '50%': { backgroundPosition: '100% 50%' },
              '100%': { backgroundPosition: '0% 50%' },
            },
          }}
        >
          <Stack direction={mdUp ? 'row' : 'column'}>
            <Box pt={2}>
              <Typography variant="caption" sx={{ color: 'grey.200', fontSize: 11, pl: 4, pt: 3 }}>
                ONLINE COURSE
              </Typography>
              <Box sx={{ padding: 2 }}>
                <Typography variant="h5" sx={{ color: 'white' }}>
                  Hello..Choosing the Right Online <br />
                  <ReactTyped
                    strings={[
                      'Course For Students',
                      `Course For ${leadDetails ? leadDetails.name : 'Course For Students'}`,
                    ]}
                    typeSpeed={30}
                    backSpeed={30}
                    // attr="placeholder"
                    loop
                  />
                </Typography>
                <Box pt={2}>
                  <Stack direction={smUp ? 'row' : 'column'} spacing={2}>
                    <Box pt={1.5}>
                      <Button
                        variant="contained"
                        sx={{
                          borderRadius: 4,
                          backgroundColor: 'black',
                          color: 'white',
                        }}
                      >
                        <Icon icon="hugeicons:course" />
                        <Typography variant="caption">View Courses</Typography>
                      </Button>
                    </Box>
                    <Box>
                      <Box sx={{ minWidth: 300 }}>
                        <FormControl fullWidth>
                          <Autocomplete
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '16px',
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'white',
                                },
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 2,
                                borderColor: 'white',
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'white',
                              },
                              '& .MuiInputBase-input': {
                                color: 'white',
                              },
                              '& .MuiAutocomplete-popupIndicator': {
                                color: 'white',
                              },
                              '& .MuiAutocomplete-clearIndicator': {
                                color: 'white',
                              },
                            }}
                            options={CourseDetails}
                            getOptionLabel={(option) => option.courseName}
                            value={selectedCourse || null}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                delete newValue.options;
                                delete newValue.courseImg;
                                delete newValue.img;
                                newValue['subjects'] = [];
                                newValue['discount'] = '';
                                newValue['currencyType'] = '';
                                newValue['booksAndPublication'] = '';
                                newValue['preferredChapter'] = '';
                                newValue['levelOpted'] = '';
                                newValue['selectedOption'] = '';
                                newValue['priceId'] = '';
                                newValue['selectedCurrency'] = null;
                                newValue['isRetention'] = 0;
                                // ----------------test------------------------
                                // newValue["courseTypeId"] = 2;
                                // newValue["courseLevelStatus"] = false;
                              }
                              setSelectedCourse(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Available Courses"
                                InputLabelProps={{
                                  sx: {
                                    color: 'white',
                                    '&.Mui-focused': {
                                      color: 'white',
                                    },
                                  },
                                }}
                                sx={{
                                  '& .MuiInputLabel-shrink': {
                                    color: 'white',
                                  },
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Box>
                    </Box>
                    {/* {selectedCourse != {} ? ( */}
                    <Box
                      pt={1.4}
                      sx={{
                        display: smUp ? null : 'flex',
                        justifyContent: smUp ? null : 'center',
                      }}
                    >
                      <Button
                        onClick={handleSubmit}
                        sx={{
                          color: '#0089d0',
                          backgroundColor: 'white',
                          borderRadius: 3,
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: '#0089d0',
                            color: 'white',
                          },
                        }}
                      >
                        <Icon icon="line-md:plus-circle" height={22} width={22} />
                      </Button>
                    </Box>
                    {/* ) : null} */}
                  </Stack>
                </Box>
              </Box>
            </Box>
          </Stack>
          {/* Image positioned at the bottom-right with reduced opacity */}
          {mdUp ? (
            <Box
              sx={{
                position: 'absolute',
                right: 20,
                bottom: 45,
              }}
            >
              <img src={headerImg} alt="header img" height={110} width={150} />
            </Box>
          ) : null}
        </Paper>
      </Box>
      <PercentageCurrencyType
        open={open}
        setOpen={setOpen}
        handleCurrencyTypeChange={handleCurrencyTypeChange}
        CurrencyType={CurrencyType}
        setCurrencyType={setCurrencyType}
        handleSave={handleSave}
      />
    </motion.div>
  );
};

export default CartHeader;
